import {BaseFormModel} from './base-form-model';
import {CardSummary} from './card-summary';

export class CardTransactionResponse extends BaseFormModel<CardTransactionResponse> {
    objectType: string;
    objectId: number;
    organizationId: number;
    createDate: Date;
    responseDate: Date;
    code: number;
    message: string;
    referenceId: string;
    cardSummary: CardSummary;
}
